/**
 * A PERCENTAGE AS THE PAGE'S LANGUAGE WRITES IT.
 *
 * Persian sets the sign on the left of the figure — «٪۱۰۰», «+٪۱٫۵۵» — and
 * English after it — "100%", "+1.55%". Every percentage on the site goes
 * through here, so they all agree (before this, ~25 places wrote their own
 * `${n}٪`, some with an ASCII "%" on the Persian page).
 *
 * The Persian run is wrapped in a left-to-right isolate (LRI … PDI): whatever
 * surrounds it — a right-to-left paragraph, a `<bdi>`, a `dir="ltr"` cell — it
 * draws the same way. Without it a signed figure went either way, because
 * `Intl.NumberFormat("fa-IR")` puts a left-to-right mark before the sign.
 */

const LRI = "⁦";
const PDI = "⁩";
/** The direction marks `Intl` adds around a Persian sign. */
const MARKS = /[‎‏؜]/g;

/** A figure already formatted for the page ("۱۰۰", "+۱٫۵۵", "12.5") with its percent sign. */
export function withPercent(formatted: string, isFa: boolean): string {
  const text = formatted.replace(MARKS, "").trim();
  if (!isFa) return `${text}%`;
  const sign = /^[+\-−]/.test(text) ? text[0] : "";
  return `${LRI}${sign}٪${text.slice(sign.length)}${PDI}`;
}

/** A number as a percentage in the page's digits: 12.5 → «٪۱۲٫۵» / "12.5%". */
export function formatPercent(value: number, isFa: boolean, options: Intl.NumberFormatOptions = { maximumFractionDigits: 1 }): string {
  return withPercent(new Intl.NumberFormat(isFa ? "fa-IR" : "en-US", options).format(value), isFa);
}
